// extracted by mini-css-extract-plugin
export default {"flex_container":"contact_flex_container__7gMxX","custom_span":"contact_custom_span__9ciW5"};